import React from 'react'
import { Link } from 'react-router-dom'
import { func, object } from 'prop-types'
import moment from 'moment'
import styles from './WeekTable.styl'
import Icon from '../Icons/Icon'
import FaArrowCircleLeft from 'react-icons/lib/fa/arrow-circle-left'
import FaArrowCircleRight from 'react-icons/lib/fa/arrow-circle-right'
import { translateSport, translateGround, translateType, translateMonth } from '../../helpers/helpers'


export default class WeekTable extends React.Component {

	static propTypes = {
		date: object,
		week: object,
		onChange: func
	}

	constructor(props) {
		super(props)
		const { week } = props

		this.state = {
			dropdown: false,
			weekState: 0,
			week: this.computeWeekWorkouts(week)
		}
	}

	componentWillReceiveProps(nextProps) {
		const { week } = nextProps
		this.setState({
			week: this.computeWeekWorkouts(week)
		})
	}

	computeWeekWorkouts(week = {}) {
		return (week.workouts || []).reduce((computed, workout) => {
			const { priority, day } = workout
			computed[priority][day] = workout
			return computed
		}, { primary: new Array(7).fill({}), secondary: new Array(7).fill({}) })
	}

	checkIfEmpty(workout) {
		if (!Object.keys(workout).length) {
			return styles['empty']
		}
	}

	renderTable(week) {
		const { date } = this.props

		const labelHeader = ['2ª Feira', '3ª Feira', '4ª Feira', '5ª Feira', '6ª Feira', 'Sábado', 'Domingo'].map((label, index) => (
			<td
				key={ `${ index }_day` }
				className={ this.checkIfEmpty(week[index]) }
			>
				<Link to={ { pathname: '/apt/workout/daily', state: (date.valueOf() + index * 24 * 60 * 60 * 1000) } }>
					{ label }
				</Link>
			</td>
		))

		const type = [[<td key={ 'type' } className={ styles.type } />]]
		const ground = [[<td key={ 'ground' }>Tipo de Treino</td>]]
		const slope = [[<td key={ 'slope' }>Altimetria</td>]]
		const zone = [[<td key={ 'zone' }>Zona UT</td>]]
		const time = [[<td key={ 'time' }>Tempo<br />(min)</td>]]
		const distance = [[<td key={ 'distance' }>Distância<br />(km)</td>]]
		const speed = [[<td key={ 'speed' }>Velocidade média<br />(km/h)</td>]]
		const pace = [[<td key={ 'pace' }>Ritmo<br />(mim/km)</td>]]
		const FCmed = [[<td key={ 'FCmed' }>FC média<br />(ppm)</td>]]
		const FCmax = [[<td key={ 'FCmax' }>FC máxima<br />(ppm)</td>]]
		const calories = [[<td key={ 'calories' }>Calorias</td>]]
		const DA = [[<td key={ 'DA' }>D. Acumulado</td>]]
		const DP = [[<td key={ 'DA' }>D. Positivo</td>]]
		const heightDiference = [[<td key={ 'heightDiference' }>Desníveis acum. DA<br />Desníveis positivo D+</td>]]
		const flexWorkout = [[<td key={ 'CF' }>Circuito Flexibilidade</td>]]
		const weightWorkout = [[<td key={ 'CM' }>Circuito Musculação</td>]]

		week.forEach((workout, i) => {
			type.push(<td className={ `${ this.checkIfEmpty(workout) } ${ styles.type }` } key={ `${ i }_type` }>{ translateType(workout.type) }</td>)
			zone.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_zone` }>{ workout.goal ? workout.goal.name : '' }</td>)
			ground.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_ground` }><div><i>{ workout.ground ? <Icon name={ translateGround(workout.ground.name) } /> : '' }</i><i>{ workout.sport ? <Icon name={ translateSport(workout.sport) } /> : '' }</i></div></td>)
			slope.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_slope` }>{ workout.slope ? <i className={ styles.slopes }><Icon name={ workout.slope.name } /></i> : '' }</td>)
			time.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_time` }>{ workout.currentParams ? workout.currentParams.time : '' }<span>{ workout.athleteParams ? ` / ${ workout.athleteParams.time }` : '' }</span></td>)
			distance.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_distance` }>{ workout.currentParams ? workout.currentParams.distance : '' }<span>{ workout.athleteParams ? ` / ${ workout.athleteParams.distance }` : '' }</span></td>)
			speed.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_speed` }>{ workout.currentParams ? workout.currentParams.averageSpeed : '' }<span>{ workout.athleteParams ? ` / ${ workout.athleteParams.averageSpeed }` : '' }</span></td>)
			pace.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_pace` }>{ workout.currentParams ? workout.currentParams.pace : '' }<span>{ workout.athleteParams ? ` / ${ workout.athleteParams.pace }` : '' }</span></td>)
			FCmed.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_FCmed` }>{ workout.currentParams ? workout.currentParams.averageBPM : '' }<span>{ workout.athleteParams ? ` / ${ workout.athleteParams.averageBPM }` : '' }</span></td>)
			FCmax.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_FCmax` }>{ workout.currentParams ? workout.currentParams.maxBPM : '' }<span>{ workout.athleteParams ? ` / ${ workout.athleteParams.maxBPM }` : '' }</span></td>)
			calories.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_calories` }>{ workout.currentParams ? workout.currentParams.calories : '' }<span>{ workout.athleteParams ? ` / ${ workout.athleteParams.calories }` : '' }</span></td>)
			heightDiference.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_heightDiference` }>{ workout.currentParams ? '--' : '' }<span>{ workout.athleteParams ? '' : '' }</span></td>)
			flexWorkout.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_CF` }>{ workout.flexWorkoutInfo && workout.flexWorkoutInfo.reps ? `${ workout.flexWorkoutInfo.reps } x ${ workout.flexWorkout.name }` : Object.keys(workout).length ? '--' : '' }</td>)
			weightWorkout.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_CM` }>{ workout.weightWorkoutInfo && workout.weightWorkoutInfo.reps ? `${ workout.weightWorkoutInfo.reps } x ${ workout.weightWorkout.name }` : Object.keys(workout).length ? '--' : '' }</td>)
			DA.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_CM` }><span>{ workout.athleteParams ? `${ workout.athleteParams.DA || '' }` : '' }</span></td>)
			DP.push(<td className={ this.checkIfEmpty(workout) } key={ `${ i }_CM` }><span>{ workout.athleteParams ? `${ workout.athleteParams.DP || '' }` : '' }</span></td>)
		})

		return (
			<table className={ styles['table'] }>
				<thead>
					<tr>{ type }</tr>
					<tr><td />{ labelHeader }</tr>
				</thead>
				<tbody>
					<tr>{ ground }</tr>
					<tr>{ zone }</tr>
					<tr>{ slope }</tr>
					<tr>{ time }</tr>
					<tr>{ distance }</tr>
					<tr>{ speed }</tr>
					<tr>{ pace }</tr>
					<tr>{ FCmed }</tr>
					<tr>{ FCmax }</tr>
					<tr>{ DA }</tr>
					<tr>{ DP }</tr>
					<tr>{ calories }</tr>
					<tr>{ heightDiference }</tr>
					<tr>{ weightWorkout }</tr>
					<tr>{ flexWorkout }</tr>
				</tbody>
			</table>
		)
	}

	renderDateTitle() {
		const { date } = this.props
		const endDate = moment.utc(date.valueOf()).add(6, 'days').endOf('day')
		return <h3>{ `${ date.date() } de ${ translateMonth[date.month()] } - ${ endDate.date() } de ${ translateMonth[endDate.month()] }` }</h3>
	}

	render() {
		const { dropdown, weekState, week } = this.state
		const { week: propsWeek } = this.props

		return (
			<div className={ styles.section }>
				<nav className={ styles.nav }>
					<ul className={ styles.weekNav }>
						<li
							className={ styles.arrow } onClick={ () => {
								if (weekState === -2) { return }
								this.setState(prevState => ({ weekState: prevState.weekState - 1 }))
								this.props.onChange(-1)
							} }
						><FaArrowCircleLeft /></li>
						<li>
							{ this.renderDateTitle() }
							{ propsWeek && propsWeek.weekYear ? <p>{ `Microciclo ${ propsWeek.weekYear } - ${ new Date().getFullYear() }` }</p> : null }
						</li>
						<li
							className={ styles.arrow } onClick={ () => {
								if (weekState === 1) { return }
								this.setState(prevState => ({ weekState: prevState.weekState + 1 }))
								this.props.onChange(1)
							} }
						><FaArrowCircleRight /></li>
					</ul>
				</nav>
				{ this.renderTable(week['primary']) }
				<div>
					<div className={ styles.orangeBar } onClick={ () => this.setState({ dropdown: (dropdown === false) }) }> { dropdown ? 'Esconder ' : 'Ver ' }Treinos Secundários</div>
					{ dropdown ? this.renderTable(week['secondary']) : null }
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/webapp/components/WeekTable/WeekTable.js